import React, { useState } from 'react'
import { IconButton, Dialog, DialogContent, Box } from '@mui/material'
import ImageRoundedIcon from '@mui/icons-material/ImageRounded'
import { useFetchImageUrl } from '../../hooks/componentHooks/useFetchImageUrl'
import LoadingBackdrop from '../Common/Loading/LoadingBackdrop'
import { useLoading } from '../../context/LoadingContext'

interface ViewImageProps {
  imageFileName: string
}

const ViewImage: React.FC<ViewImageProps> = ({ imageFileName }) => {
  const [open, setOpen] = useState(false)

  const isDisabled = imageFileName ? false : true

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    setOpen(true)
  }
  const handleClose = () => setOpen(false)

  const { imageUrl } = useFetchImageUrl('images', imageFileName ?? '', 'feedback', open)

  const { loading } = useLoading()

  const [size, setSize] = React.useState<{ width: number; height: number } | null>(null)

  const handleImgLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget
    const naturalW = img.naturalWidth
    const naturalH = img.naturalHeight
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)

    const maxW = vw * 0.9
    const maxH = vh * 0.9

    const scale = Math.min(1, Math.min(maxW / naturalW, maxH / naturalH))
    setSize({ width: Math.round(naturalW * scale), height: Math.round(naturalH * scale) })
  }

  const paperSx = size
    ? {
        width: `${size.width}px`,
        height: `${size.height}px`,
        maxWidth: '95vw',
        maxHeight: '95vh',
        margin: 0,
        borderRadius: 1,
        overflow: 'hidden',
      }
    : {
        width: { xs: '95vw', sm: '75vw', md: '60vw' },
        height: { xs: '95vh', sm: '75vh', md: '60vh' },
        margin: 0,
        borderRadius: 1,
        overflow: 'hidden',
      }

  return (
    <>
      <IconButton size='small' onClick={handleIconClick} color='primary' disabled={isDisabled}>
        <ImageRoundedIcon />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={false}
        maxWidth={false}
        slotProps={{
          paper: {
            sx: paperSx,
          },
        }}
      >
        {imageUrl ? (
          <DialogContent
            sx={{
              p: 0,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              component='img'
              src={imageUrl}
              onLoad={handleImgLoad}
              sx={{
                width: size ? `${size.width}px` : '100%',
                height: size ? `${size.height}px` : '100%',
                objectFit: 'contain',
                display: 'block',
              }}
            />
          </DialogContent>
        ) : (
          <LoadingBackdrop message={'Loading image...'} />
        )}
        {loading && <LoadingBackdrop message={'Sending feedback...'} />}
      </Dialog>
    </>
  )
}

export default ViewImage
